// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Step } from '@med/app/home/demo/guided-tour/models/step';

@Component({
  selector: 'e-guided-tour-skeleton',
  templateUrl: './guided-tour-skeleton.component.html',
  styleUrls: ['./guided-tour-skeleton.component.scss'],
})
export class GuidedTourSkeletonComponent {
  @Input() step: Step;
  @Output() exitDemoClick = new EventEmitter<void>();
}
